module.exports = __webpack_public_path__ + "static/media/Logo_La_Conception.b389c22c.jpg";